export const GOOGLE_CLIENT_ID = process.env
  .REACT_APP_GOOGLE_CLIENT_ID as string;
export const USER_ACCESS_KEY = 'access.user.inspection_app';
export const GOOGLE_USER_ACCESS_KEY = 'inspection_app_auth';
export const GOOGLE_USER_ACCESS_REFRESH_TOKEN = 'inspection_app_auth_refresh';
export const GOOGLE_USER_UUID = 'inspection_app_uuid';
